import MenuCollapse from './MenuCollapse'
import { MenuProvider } from './MenuContext'

interface MenuUIProps {
  displayMenu: boolean
  closeMenu: () => void
}

const MenuUI = ({ displayMenu, closeMenu }: MenuUIProps) => {
  return (
    <MenuProvider>
      <MenuCollapse toggleMenu={closeMenu} />
    </MenuProvider>
  )
}

export default MenuUI
